const h = (r, c) => {
  var i;
  if (r && r.current) {
    const n = r.current.children[0].children, o = n[c].clientWidth;
    let l = 0;
    for (let t = 0; t < c; t++)
      l += n[t].clientWidth;
    (i = r.current) == null || i.scrollTo(
      0 - r.current.offsetWidth / 2 + l + o * 0.5,
      0
    );
  }
};
export {
  h as handleTabsReposition
};
